import { Box, Button, Heading } from '@wix/design-system';
import {
  Ellipsis,
  Title as PackagePickerTitle,
} from '@wix/package-picker-components';
import { useAppTitles } from 'components/AppTitle/useAppTitles';
import { BackButton } from 'components/BackButton/AdvancedPlans/BackButton';
import { Experiments } from 'enums';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { getDomainName } from 'utils';
import { RootStore, withInjectedRootStore } from '../../../providers';
import { ShowCaseFeatures } from '../AccountLevelFeatures/ShowCaseFeatures';
import s from './Title.scss';

interface TitleProps {
  showBackButton: boolean;
  onBack(): void;
  currentStep: number;
  isSecondStepDisabled: boolean;
  rootStore: RootStore;
}

export const TitleComp: React.FC<TitleProps> = ({
  showBackButton,
  onBack,
  currentStep,
  isSecondStepDisabled,
  rootStore,
}) => {
  const { t } = useTranslation();
  const { appTitle } = useAppTitles(rootStore.appStore);
  const {
    isAnonymous,
    getSignInRedirectionLink,
    appContext: { biLogger },
    experiments,
  } = rootStore.appStore;
  const domainName = getDomainName(experiments);
  const isNewStudioAnonymousContentEnabled =
    experiments[Experiments.NewStudioAnonymousContent] === 'true';

  const handleAnonymousCtaClick = () => {
    const targetUrl = getSignInRedirectionLink();
    biLogger.logAnonymousCtaClick({
      targetUrl,
      ctaName: 'studio-anonymous-top-cta',
    });
    window.open(targetUrl, '_self');
  };
  const title = (
    <Trans
      i18nKey={appTitle}
      values={{ domainName }}
      components={{
        ellipsis: domainName ? (
          <Ellipsis
            text={domainName}
            as={Heading}
            componentProps={{ size: 'large' }}
          />
        ) : (
          <></>
        ),
      }}
    />
  );

  return (
    <Box direction='vertical' align='center'>
      <PackagePickerTitle
        className={s.titleContainer}
        title={title}
        size='extraLarge'
        paddingTop='30px'
        gap='18px'
      >
        <Box direction='vertical'>
          <Box
            direction='horizontal'
            paddingBottom={isAnonymous ? '0' : '42px'}
          >
            {showBackButton && (
              <BackButton
                className={s.backButton}
                handleOnBackButtonClick={onBack}
                currentStep={currentStep}
                isSecondStepDisabled={isSecondStepDisabled}
              />
            )}
            <ShowCaseFeatures />
          </Box>
          {isAnonymous && (
            <Box margin='SP5 auto SP3 auto'>
              <Button
                skin='premium'
                onClick={handleAnonymousCtaClick}
                className={s.wixStudioCtaColor}
              >
                {isNewStudioAnonymousContentEnabled
                  ? t('studio_package_picker.anon.CTA')
                  : t('studio_package_picker.anon.main_CTA')}
              </Button>
            </Box>
          )}
        </Box>
      </PackagePickerTitle>
    </Box>
  );
};

export const Title = withInjectedRootStore(TitleComp);
